import Swiper, { Navigation, Pagination, Lazy, A11y, Autoplay } from 'swiper';
import InfinityScroll from '../components/infinityScroll';
import setCarousel from '../components/carousel';
import { updatePriceBlock } from '../components/utilities';
import setProductSlider from '../components/product_slider';

Swiper.use([Navigation, Pagination, Lazy, Autoplay]);

const Home = {
  setFullbanner: () => {
    const fullbanners = document.querySelectorAll('[data-fullbanner]');

    let resolution = 'desktop';
    if (window.innerWidth > 767) resolution = 'mobile'

    // Remove o fullbanner que não é da resolução do dispositivo
    fullbanners.forEach(fullbanner => {
      if (fullbanner.classList.contains(`-${resolution}`)) {
        fullbanner.parentElement.removeChild(fullbanner)
      }
    })

    fullbanners.forEach((section) => {
      const carousel = section.querySelector('.swiper');
      const pagination = section.querySelector('.swiper-pagination');
      const next = section.querySelector('.swiper-button-next');
      const prev = section.querySelector('.swiper-button-prev');

      new Swiper(carousel, {
        slidesPerView: 1,
        watchOverflow: true,
        preloadImages: false,
        speed: 1000,
        autoplay: true,
        lazy: {
          checkInView: true,
          loadPrevNext: false,
          loadOnTransitionStart: true,
        },
        navigation: {
          nextEl: next,
          prevEl: prev,
        },
        pagination: {
          el: pagination,
          type: 'bullets',
          clickable: true,
        },
      });
    });
  },
  setSliderHome: function () {
    var sliderSectionHome = new Swiper('#swiper-section', {
      loop: false,
      slidesPerView: 1.7,
      spaceBetween: 15,
      watchOverflow: true,
      pagination: {
        el: '.swiper-pagination-section',
        type: 'bullets',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '"></span>';
        },
      },
      breakpoints: {
        640: {
          slidesPerView: 1.7,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 1.7,
          spaceBetween: 30,
        },
        1024: {
          slidesPerView: 3.3,
          spaceBetween: 40,
        },
      },
    });
  },
  setInstagramSwiper: function () {
    const instagramSwiper = new Swiper('[data-instagram-swiper]', {
      slidesPerView: 2.3,
      slidesPerGroup: 1,
      spaceBetween: 10,
      preloadImages: false,
      speed: 1000,
      lazy: {
        checkInView: true,
        loadPrevNext: true,
        loadOnTransitionStart: true,
        loadPrevNextAmount: 4,
      },
      breakpoints: {
        768: {
          slidesPerView: 4,
        },
        992: {
          slidesPerView: 6,
          spaceBetween: 0,
        },
      },
      pagination: {
        el: '[data-instagram-swiper] .swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
    });
  },
  init: function () {
    const _this = this;

    _this.setFullbanner();
    _this.setSliderHome();
    _this.setInstagramSwiper();
    setProductSlider()


    $('.category-tabs .links a').on('click', function (e) {
      e.preventDefault();
      $('.category-tabs .links a').removeClass('active');
      $(this).addClass('active');
      var tag = $(this).attr('href');
      $('.category-tabs .item').removeClass('active');
      $('[data-link="' + tag + '"]').addClass('active');
    });

    setCarousel();
    updatePriceBlock();
    InfinityScroll.init();
  },
};

window.addEventListener('DOMContentLoaded', () => {
  Home.init();
})

$(document).ready(function(){

  $('.incrementarQuantidade').on('click', function(){

    let quantidadeInput = $(this).prev().val()
    let quantidadeInteira = parseFloat(quantidadeInput)

    $(this).prev().val(quantidadeInteira + 1)

    $(this).parent().next().find('input[name="quantity"]').val(quantidadeInteira + 1)

  })

  $('.decrementarQuantidade').on('click', function(){

    let quantidadeInput = $(this).next()
    let quantidadeInteira = parseFloat(quantidadeInput.val())

    if (quantidadeInteira > 1) {
      quantidadeInput.val(quantidadeInteira - 1)
      $(quantidadeInput).parent().next().find('input[name="quantity"]').val(quantidadeInteira - 1)
    }    

  })

});
